import React, { useEffect } from 'react';
import { Card, Col, Row, Spin, Button, Space } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { USER } from '../../../graphql/queries/users';
import { Profile } from '../../../components/Profile/View';
import { EditOutlined } from '@ant-design/icons';
import { ContractorInfoCard } from '../../../components/Contractor/ContractorInfoCard';

const UserView: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    loading,
    data = {},
    refetch,
  } = useQuery(USER, {
    variables: { id },
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const { user } = data;

  if (!loading && !user) {
    return (
      <Row justify="center" align="middle" style={{ minHeight: '60vh' }}>
        <Col>
          <Card>
            <h2>User not found</h2>
            <Button type="primary" onClick={() => navigate('/admin/users')}>
              Back to Users List
            </Button>
          </Card>
        </Col>
      </Row>
    );
  }

  if (loading && !user) {
    return (
      <Row justify="center" align="middle" style={{ minHeight: '60vh' }}>
        <Col>
          <Spin size="large" />
        </Col>
      </Row>
    );
  }

  return (
    <Row gutter={[16, 16]} justify="center">
      <Col xs={24} sm={20} md={16} lg={12}>
        <Card
          extra={
            <Space>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => navigate(`/admin/user/edit/${id}`)}>
                Edit User
              </Button>
              <Button onClick={() => navigate('/admin/users')}>Back to List</Button>
            </Space>
          }>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Profile user={user} />
            <ContractorInfoCard
              contractor={user.contractor}
              isContractorUser={user.roles?.includes('CONTRACTOR') ?? false}
            />
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default UserView;
